/* ======================================================================
   custom.js — project-wide JS extensions (see CLAUDE.md).

   Heading line breaks:
   Converts "||" (always) and "|s|" (SP only) into a <br> inside heading / subheading
   elements (Prestige size classes .h1–.h6 / .heading). Works on the
   storefront and, via shopify:section:load, live in the theme editor.

   Implementation detail: replacement happens at the TEXT-NODE level (not
   innerHTML), so existing markup and event listeners are preserved.
   ====================================================================== */
(function () {
  'use strict';

  var HEADING_SELECTOR = '.h1, .h2, .h3, .h4, .h5, .h6, .heading, h1, h2, h3, h4, h5, h6'; // custom: 素の見出しタグ（リッチテキスト内の <h4> など）も対象。2026-09-14
  // custom: "||" = 常に改行 / "|s|" = SP（〜699px）だけ改行（<br class="br-sp">、表示制御は custom.css）。2026-09-14
  var DELIMITER_RE = /(\|\||\|s\|)/;
  var SP_DELIMITER = '|s|';

  function hasDelimiter(value) {
    return value.indexOf('||') !== -1 || value.indexOf(SP_DELIMITER) !== -1;
  }

  function convertTextNode(node) {
    var value = node.nodeValue;
    if (!hasDelimiter(value)) return;

    var parts = value.split(DELIMITER_RE); // 区切り文字自身も配列に残る
    var frag = document.createDocumentFragment();
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (p === '||' || p === SP_DELIMITER) {
        var br = document.createElement('br');
        if (p === SP_DELIMITER) br.className = 'br-sp';
        frag.appendChild(br);
      } else if (p !== '') {
        frag.appendChild(document.createTextNode(p));
      }
    }
    node.parentNode.replaceChild(frag, node);
  }

  function processElement(el) {
    // Collect matching text nodes first — mutating while walking is unsafe.
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var targets = [];
    var node;
    while ((node = walker.nextNode())) {
      if (hasDelimiter(node.nodeValue)) targets.push(node);
    }
    for (var i = 0; i < targets.length; i++) convertTextNode(targets[i]);
  }

  function convert(root) {
    if (!root || !root.querySelectorAll) return;
    var heads = root.querySelectorAll(HEADING_SELECTOR);
    for (var i = 0; i < heads.length; i++) processElement(heads[i]);
  }

  function init() {
    convert(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run when a section is (re)loaded so "||" converts live.
  document.addEventListener('shopify:section:load', function (event) {
    convert(event.target);
  });
})();

/* ======================================================================
   Anchor targets for STANDARD sections (see CLAUDE.md).

   The Anchor nav (custom) section can point at standard sections (Rich text,
   etc.) that have no "Anchor ID" setting. For each such link it outputs a
   mapping { heading, id }. Here we find the section whose heading text matches
   and assign that id to it, plus an ".anchor-target" class so scroll-margin-top
   applies. Existing ids are never overwritten. Works live via section:load.
   ====================================================================== */
(function () {
  'use strict';

  var HEADING_SELECTOR = '.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6';

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function collectMap() {
    var scripts = document.querySelectorAll('script[data-anchor-nav-targets]');
    var map = [];
    for (var s = 0; s < scripts.length; s++) {
      try {
        var arr = JSON.parse(scripts[s].textContent);
        if (Array.isArray(arr)) map = map.concat(arr);
      } catch (e) {}
    }
    return map;
  }

  function assignTargets() {
    var map = collectMap();
    if (!map.length) return;

    var headings = document.querySelectorAll(HEADING_SELECTOR);

    for (var e = 0; e < map.length; e++) {
      var entry = map[e];
      if (!entry || !entry.heading || !entry.id) continue;
      // Do not touch a page that already has this id (custom section, or already assigned).
      if (document.getElementById(entry.id)) continue;

      var wanted = normalize(entry.heading);

      for (var i = 0; i < headings.length; i++) {
        if (normalize(headings[i].textContent) !== wanted) continue;

        // custom: 2026-09-24 — ヘッダー（ドロワーメニュー）とフッターの項目は対象外にする。
        // ドロワーのメニュー項目は `.h6` を持つので見出しセレクタに引っかかり、
        // 「よくあるご質問」「お客さまの声」のようにページ内の見出しと同名だと
        // id をドロワー側に奪われ、ページ内リンクが先頭に飛んでしまう。
        if (headings[i].closest('header, footer, .header-sidebar, [id^="shopify-section-sections--"]')) continue;

        var section = headings[i].closest('.shopify-section');
        // Prefer the section's inner content wrapper (no id) so we scroll to the section top;
        // fall back to the heading. Never overwrite an element that already has an id.
        // custom: 先頭が <style>/<script> のセクション（custom セクションは自前 CSS を先頭に持つ）に id を付けると
        // 不可視要素なのでスクロールしない。最初の「描画される要素」を選ぶ（2026-09-15 remake の #リメイク製品一覧 で発覚）
        var target = headings[i];
        if (section) {
          var kids = section.children;
          for (var k = 0; k < kids.length; k++) {
            if (!/^(STYLE|SCRIPT|LINK|TEMPLATE|NOSCRIPT)$/.test(kids[k].tagName)) { target = kids[k]; break; }
          }
        }
        if (target.id) target = headings[i];
        if (target.id) break;

        target.id = entry.id;
        target.classList.add('anchor-target');
        break;
      }
    }
  }

  // custom: an id assigned here does not exist yet when the browser first resolves location.hash,
  // so a link arriving from OUTSIDE the page (menu, footer, another page) never scrolls. Re-apply the
  // hash once the ids are in place. In-page clicks are unaffected because the id already exists by then.
  function applyPendingHash() {
    if (!window.location.hash || window.location.hash === '#') return;
    var id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch (e) {
      id = window.location.hash.slice(1);
    }
    var el = document.getElementById(id);
    if (!el) return;
    // Only scroll when the browser has not already done it (i.e. the element is out of view).
    var rect = el.getBoundingClientRect();
    if (rect.top >= 0 && rect.top < window.innerHeight * 0.5) return;
    el.scrollIntoView();
  }

  // custom: 2026-09-24 — ハッシュがアコーディオンの項目（またはその中身）を指しているときは、
  // そのアコーディオンを開いてから位置を合わせる。`<details>` は id が details 自身に付いていると
  // ブラウザが自動で開かないため（ご利用ガイドの各項目は、id をラッパー div に持っている）。
  // フッターの「ご注文方法」のように、別ページから特定の項目に直接来る導線のために必要。
  function openAccordionForHash() {
    if (!window.location.hash || window.location.hash === '#') return null;
    var id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch (e) {
      id = window.location.hash.slice(1);
    }
    var el = document.getElementById(id);
    if (!el) return null;

    // アコーディオン「1項目」を指しているときだけ開く。セクション全体のアンカー
    // （ご利用ガイドの `#ご利用にあたって` など）で先頭の項目が勝手に開かないようにする。
    var acc = el.closest('accordion-disclosure');
    if (!acc && el.classList.contains('accordion-list-custom__item')) {
      acc = el.querySelector('accordion-disclosure');
    }
    if (!acc) return el;

    if (typeof acc.open === 'function') {
      // テーマの accordion-disclosure。instant で開くとアニメーションを挟まないので高さが即確定する。
      acc.open({ instant: true });
    } else {
      var details = acc.querySelector('details');
      if (details) {
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
      }
    }
    return el;
  }

  function run() {
    assignTargets();
    var opened = openAccordionForHash();
    applyPendingHash();
    // 開いたことで前後の高さが変わるため、描画後にもう一度合わせる。
    if (opened) {
      requestAnimationFrame(function () {
        opened.scrollIntoView();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // 同じページ内でハッシュだけが変わったときも開く（フッターの各リンクはご利用ガイド内からも押せる）。
  window.addEventListener('hashchange', function () {
    var opened = openAccordionForHash();
    if (opened) {
      requestAnimationFrame(function () {
        opened.scrollIntoView();
      });
    }
  });

  // Theme editor: re-run when any section (the nav or a target) is (re)loaded.
  document.addEventListener('shopify:section:load', assignTargets);
})();
